import { LocalNotifications, LocalNotificationSchema } from '@capacitor/local-notifications'
import { PermissionState } from '@capacitor/core'
import { Asset } from 'src/types'

const base = process.env.API_URL || 'https://ada-api.securitas.es/api'

interface ReducedNotification {
  title: string
  body: string
}

interface LaterArmResponse {
  laterArm: boolean,
  active: Asset
}

async function checkPermission (): Promise<PermissionState> {
  return (await LocalNotifications.checkPermissions()).display
}

export function checkMedia (): 'standalone' | 'browser' {
  return window.matchMedia('(display-mode: standalone)').matches ? 'standalone' : 'browser'
}

async function scheduleNotification (
  notifications: LocalNotificationSchema[]
): Promise<void> {
  const granted = await checkPermission()
  if (granted !== 'granted') return

  await LocalNotifications.schedule({
    notifications
  })
}

export async function getAsset (assetId: string, subscriberCode: string, armDate: string): Promise<LaterArmResponse> {
  const user = sessionStorage.getItem('user')
  const { token } = JSON.parse(user)

  const res = await fetch(`${base}/user/active/${assetId}/rearmed`, {
    method: 'POST',
    body: JSON.stringify({ subscriberCode, armDate }),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  })

  const data = await res.json() as LaterArmResponse
  return data
}

export function distanceNotification (asset: Asset): void {
  const { address } = asset

  showLocationNotification(address)
}

function showLocationNotification (address: string): void {
  const { title, body } = {
    title: 'Comprobando estado',
    body: 'Te has alejado mas de 100 metros de el inmueble ' +
      `${address} y continua desarmado`
  }
  createNotification({ title, body })
}

export function createNotification ({ title, body }: ReducedNotification): void {
  try {
    checkMedia() === 'standalone'
      ? buildSwNotification({ title, body })
      : buildLocationNotification({ title, body })
  } catch (err) {
    console.warn('Error ocurred sending notification')
  }
}

async function buildLocationNotification ({ title, body }: ReducedNotification): Promise<void> {
  const notification: LocalNotificationSchema = {
    id: 2,
    title,
    body
  }

  await scheduleNotification([notification])
}

async function buildSwNotification ({ title, body }: ReducedNotification): Promise<void> {
  const sw = await navigator.serviceWorker.getRegistration()

  if ('Notification' in window && Notification.permission !== 'granted') return

  await sw.showNotification(title, {
    body,
    icon: '/images/pwa/notification_512.png'
  })
}
